import { emailApiClient } from './emailApiClient';

export interface DeleteAttachmentResponse {
  fileId: string;
  status: string;
}

export const deleteAttachment = async (contactId: string, fileId: string): Promise<DeleteAttachmentResponse> => {
  const response = await emailApiClient('/attachment/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json'
    },
    body: JSON.stringify({ contactId, fileId })
  });

  if (!response.ok) {
    throw new Error(`API responded with status ${response.status}`);
  }

  return (await response.json()) as DeleteAttachmentResponse;
};
